// extracted by mini-css-extract-plugin
module.exports = {"text-wrapper":"AuthText_text-wrapper__kZJF8","heading":"AuthText_heading__u8ktd","sub-heading":"AuthText_sub-heading__Z330L"};